import { FC } from "react";
import { BillingInterval, PlanType } from "sdk/types";
import { useGetMembershipPaymentAction } from "../hooks";
import { ChargesAtEndOfTrial } from "./ChargesAtEndOfTrial";
import { ChargesNow } from "./ChargesNow";

interface Props {
  billingInterval: BillingInterval;
  fullPrice: number;
  type: PlanType;
}

export const ChargesOverview: FC<Props> = ({
  billingInterval,
  fullPrice,
  type,
}) => {
  const action = useGetMembershipPaymentAction();

  if (action == "extend") {
    return (
      <ChargesAtEndOfTrial
        fullPrice={fullPrice}
        type={type}
        billingInterval={billingInterval}
      />
    );
  } else {
    return (
      <ChargesNow fullPrice={fullPrice} billingInterval={billingInterval} />
    );
  }
};
